/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(function () {
  $.event.special.touchstart = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchstart", handle, {
        passive: !ns.includes("noPreventDefault"),
      });
    },
  };
  $.event.special.touchmove = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchmove", handle, {
        passive: !ns.includes("noPreventDefault"),
      });
    },
  };
  $.event.special.wheel = {
    setup: function (_, ns, handle) {
      this.addEventListener("wheel", handle, { passive: true });
    },
  };
  $.event.special.mousewheel = {
    setup: function (_, ns, handle) {
      this.addEventListener("mousewheel", handle, { passive: true });
    },
  };
  /* Reformat product page body */
  $(".ProductMeta__Description .Rte").each(function () {
    $("meta", this).remove();
    var $newContent = $("<div>").addClass("ProductTabs__Container");
    var $tabNav = $("<div>").addClass("ProductTabs__Nav");
    var $tabContent = $("<div>").addClass("ProductTabs__Content");
    var headingCount = 0;
    var fitGuideContent = null;
    var currentSection = null;
    var sections = [];
    var fabricSection = null;
    var careSection = null;

    $(this)
      .children()
      .each(function () {
        if ($(this).is("h1") || $(this).is("h2") || $(this).is("h3")) {
          headingCount++;
          if (currentSection) {
            sections.push(currentSection);
          }
          currentSection = {
            title: $(this).text(),
            content: [],
          };
        } else {
          if (currentSection) {
            currentSection.content.push($(this).get(0).outerHTML);
          }
        }
      });
    if (currentSection) {
      sections.push(currentSection);
    }
    sections.forEach(function (section) {
      var sectionTitle = section.title.toLowerCase();
      if (sectionTitle.includes("fabric")) {
        fabricSection = section;
      } else if (sectionTitle.includes("care")) {
        careSection = section;
      }
    });

    if (sections.length > 0) {
      var tabIndex = 0;
      var hasFabricAndCare = fabricSection && careSection;

      function createTab(title, content) {
        var $tabButton = $("<button>")
          .addClass("ProductTabs__Button")
          .addClass(tabIndex === 0 ? "ProductTabs__Button--active" : "")
          .attr("data-tab", "tab-" + tabIndex)
          .text(title);
        $tabNav.append($tabButton);

        var $tabPane = $("<div>")
          .addClass("ProductTabs__Pane")
          .addClass(tabIndex === 0 ? "ProductTabs__Pane--active" : "")
          .attr("data-tab-content", "tab-" + tabIndex)
          .html(content);

        $tabContent.append($tabPane);
        tabIndex++;
      }

      sections.forEach(function (section, index) {
        var sectionTitle = section.title.toLowerCase();
        if (!section.title.trim() || section.content.length === 0) {
          return;
        }
        if (sectionTitle.includes("fit guide")) {
          fitGuideContent = section.content.join("");
          return;
        }
        if (hasFabricAndCare) {
          if (sectionTitle.includes("fabric")) {
            createTab(
              "FABRIC & CARE",
              fabricSection.content.concat(careSection.content).join("")
            );
            return;
          } else if (sectionTitle.includes("care")) {
            return;
          }
        }
        createTab(section.title, section.content.join(""));
      });

      if ($tabNav.children().length > 0) {
        var $navWrapper = $("<div>").addClass("ProductTabs__NavWrapper");
        var $arrowLeft = $("<button>")
          .addClass("ProductTabs__NavArrow ProductTabs__NavArrow--left icon-arrow-left")
          .attr("type", "button")
          .attr("aria-label", "Scroll left")
          .html('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"/></svg>');
        var $arrowRight = $("<button>")
          .addClass("ProductTabs__NavArrow ProductTabs__NavArrow--right icon-arrow-right")
          .attr("type", "button")
          .attr("aria-label", "Scroll right")
          .html('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"/></svg>');
        $navWrapper.append($arrowLeft, $tabNav, $arrowRight);
        $newContent.append($navWrapper);
        $newContent.append($tabContent);

        var scrollAmount = 120;
        $arrowLeft.on("click", function(e) {
          e.preventDefault();
          $tabNav.animate({ scrollLeft: $tabNav.scrollLeft() - scrollAmount }, 200);
        });
        $arrowRight.on("click", function(e) {
          e.preventDefault();
          $tabNav.animate({ scrollLeft: $tabNav.scrollLeft() + scrollAmount }, 200);
        });
        $tabNav.on("scroll", function() {
          updateTabNavArrows($tabNav, $arrowLeft, $arrowRight);
        });
        $(window).on("resize", function() {
          updateTabNavArrows($tabNav, $arrowLeft, $arrowRight);
        });
        setTimeout(function() {
          updateTabNavArrows($tabNav, $arrowLeft, $arrowRight);
        }, 100);
      }
    }

    $(this).html("").append($newContent);
    $(this).removeClass("hide");

    if (fitGuideContent) {
      setTimeout(function () {
        var $firstTabPane = $tabContent.find("[data-tab-content='tab-0']");
        var $sizeChartDrawer = $("#size-chart-drawer .Drawer__Content .Rte");
        if ($sizeChartDrawer.length > 0) {
          $sizeChartDrawer.append(
            '<div class="FitGuide__Section" style="font-weight: bold;">' +
              fitGuideContent +
              "</div>"
          );
        }
        $firstTabPane.append(
          '<div class="FitGuide__Section" style="font-weight: bold;">' +
            fitGuideContent +
            "</div>"
        );
      }, 100);
    }
  });

  $(document).on("click", ".ProductTabs__Button", function () {
    var $this = $(this);
    var tabId = $this.attr("data-tab");
    var $tabContainer = $this.closest(".ProductMeta__Description");

    $tabContainer
      .find(".ProductTabs__Button")
      .removeClass("ProductTabs__Button--active");
    $this.addClass("ProductTabs__Button--active");

    $tabContainer
      .find(".ProductTabs__Pane")
      .removeClass("ProductTabs__Pane--active");
    $tabContainer
      .find('[data-tab-content="' + tabId + '"]')
      .addClass("ProductTabs__Pane--active");
  });

  $(document).ready(function () {
    const errorMessageDuration = 2500;

    // Function to display error message
    function showErrorMessage(sizeText, addToCartButton) {
      const errorMessage = $("<span>", {
        class: "ProductForm__Error Alert Alert--error",
        html: `Size ${sizeText} is not available for this product. Contact us for more options.`,
      });
      // Display error message and remove it after a timeout
      addToCartButton.prop("disabled", false);
      errorMessage.insertAfter(addToCartButton);
      setTimeout(() => {
        errorMessage.remove();
      }, errorMessageDuration);
    }

    // Event: Unavailable size click on PDP
    $(
      ".SizeSwatchList .HorizontalList__Item .SizeSwatch__Radio.Disabled+.SizeSwatch"
    ).on("click", function () {
      const addToCartButton = $(".ProductForm__AddToCart");
      const sizeText = $(this).text();
      const hasBackInStockTag = $('.ProductForm__BackInStock.is-back-in-stock').length > 0;
      
      if (hasBackInStockTag) {
        // For back in stock items, show the back in stock button instead of error
        $('.ProductForm__BackInStock.is-back-in-stock').show();
      } else {
        showErrorMessage(sizeText, addToCartButton);
      }
    });

    // Temporary holder for Add to Cart button content
    window.tempHtmlHolder = "";

    // Function to handle button state for quickview modal
    function updateAddToCartButton(isDisabled, addToCartButton) {
      if (isDisabled) {
        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.classList.replace(
          "Button--primary",
          "Button--secondary"
        );
        addToCartButton.removeAttribute("data-action");
        // Store the current button HTML if not already set to 'Sold Out'
        if (
          addToCartButton.innerHTML.trim() !==
          window.languages.productFormSoldOut
        ) {
          window.tempHtmlHolder = addToCartButton.innerHTML;
        }
        // Set button text to 'Sold Out'
        addToCartButton.innerHTML = window.languages.productFormSoldOut;
      } else {
        // Re-enable button and restore original state
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.replace(
          "Button--secondary",
          "Button--primary"
        );
        addToCartButton.setAttribute("data-action", "add-to-cart");
        if (window.tempHtmlHolder) {
          addToCartButton.innerHTML = window.tempHtmlHolder;
        }
      }
    }

    // Event: Unavailable size click in quickview modal
    $(document).on(
      "click",
      ".quickview-modal .SizeSwatchList .HorizontalList__Item .SizeSwatch__Radio+.SizeSwatch",
      function (e) {
        const isDisabled =
          e.target.previousElementSibling.classList.contains("Disabled");
        const addToCartButton = document.querySelector(
          ".ProductForm__AddToCart"
        );
        const hasBackInStockTag = document.querySelector('.ProductForm__BackInStock.is-back-in-stock');
        
        // Update button state with a delay
        setTimeout(() => {
          if (isDisabled && hasBackInStockTag) {
            // For back in stock items, show different messaging
            addToCartButton.setAttribute("disabled", "disabled");
            addToCartButton.classList.replace("Button--primary", "Button--secondary");
            addToCartButton.removeAttribute("data-action");
            addToCartButton.innerHTML = "Notify Me When Available";
          } else {
            updateAddToCartButton(isDisabled, addToCartButton);
          }
        }, 100);
      }
    );
  });

  //Update the other price, since dpo is only able to do one
  $(".ProductMeta__Price").on("DOMSubtreeModified", function () {
    $(".CurrentPrice").html($(this).html());
  });

  //Initialize custom size selection
  $(".dpo-container .fields.custom-size option[selected]").each(function () {
    $sizeSwatches = $(".CustomSizes");
    $sizeOption = $(this);
    if ($sizeSwatches) {
      var optionText = $sizeOption.text().trim();
      $(".SizeSwatch", $sizeSwatches).removeClass("Selected");
      $(".SizeSwatch", $sizeSwatches).each(function () {
        var compareText = $(this).text().trim();
        if (optionText == compareText) {
          $(this).addClass("Selected");
        }
      });
    }
  });

  //Update selected sizes
  $(".CustomSizes .SizeSwatch").on("click", function (e) {
    var $dpoSizes = $(".dpo-container .fields.custom-size");
    var $sizeElement = $(this);
    if ($dpoSizes) {
      var sizeText = $sizeElement.text().trim();
      $("option", $dpoSizes).prop("selected", false);
      $("option", $dpoSizes).each(function () {
        var compareText = $(this).text().trim();
        if (sizeText == compareText) {
          $(this).prop("selected", true);
          $sizeElement
            .parent()
            .parent()
            .find(".SizeSwatch.Selected")
            .removeClass("Selected");
          $sizeElement.addClass("Selected");
        }
      });
    }
  });

  var sizesValidation = function (e) {
    if ($(".CustomSizes").length > 0) {
      if ($(".SizeSwatch.Selected", ".CustomSizes").length == 0) {
        $(".validation-advice", ".CustomSizes").remove();
        $(
          '<div class="validation-advice">This field is required</div>'
        ).appendTo(".CustomSizes");
        return false;
      } else {
      }
    } else {
    }
    return true;
  };
  if (window.dpoOptions) {
    window.dpoOptions.customValidation = sizesValidation;
  } else {
    jQuery(window).on("dpo_initialized", function () {
      window.dpoOptions.customValidation = sizesValidation;
    });
  }

  //Modalize Links
  $("main a").each(function () {
    var href = $(this).attr("href");
    if (href.indexOf("#") == -1 && href.indexOf("/pages/") == 0) {
      var modal_handle = href.replace("/pages/", "modal-").replace("/", "-");
      if ($("#" + modal_handle + ".Modal").length > 0) {
        $(this)
          .attr("data-action", "open-modal")
          .attr("aria-controls", modal_handle);
      }
    }
  });

  $(".template-collection #shopify-section-page-extra-content-bridal").each(
    function () {
      var $target = $("<a>")
        .attr("data-action", "open-modal")
        .attr("aria-controls", "modal-bridal-modal-content")
        .addClass("openBridalModal");
      $(".ImageHero__Image").first().wrap($target);
      if (!getCookie("bridal")) {
        setTimeout(() => {
          $(".ImageHero__Image", ".openBridalModal").click();
          setCookie("bridal", "viewed", 365);
        }, 2000);
      }
    }
  );

  $(".aa-input", ".PageContainer").on("keydown", function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      if ($(this).val()) {
        window.location.href = "/search?q=" + $(this).val();
      }
    }
  });

  var resizeTimer;
  $(window).on("resize", function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      computeStickyFacetBar();
      computeHomeSlideHeights();
    }, 250);
  });
  computeStickyFacetBar();
  computeHomeSlideHeights();

  quickviewSetup();
  $(".AnnouncementBar__Wrapper").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
  });
  $(document).on("click", ".open_chatboat", function (e) {
    e.preventDefault();
    Beacon("open");
    Beacon("navigate", "/ask/chat/"); // Chat screen

    setTimeout(function () {
      $("div#beacon-container").addClass("visible");
    }, 300);
  });
  $(document).on("click", ".Cart__Footer .note_cart button", function () {
    $(".note_cart .Cart__NoteContainer").toggleClass("active");
  });
});

var computeHomeSlideHeights = function () {
  if ($(".Slideshow__Slide").length > 0) {
    $slides = $(".Slideshow__Slide");
    $slides.each(function (idx, el) {
      var $c = $(".Slideshow__Content", el);
      if ($c.length > 0) {
        var h = $c.outerHeight();
        document.documentElement.style.setProperty(
          "--mobile-home-hero-content-height-" + (idx + 1),
          h + "px"
        );
      }
    });
  }
};

var computeStickyFacetBar = function () {
  if ($(".ais-facets").length > 0) {
    if (window.innerWidth >= 1008) {
      var windowHeight = window.innerHeight;
      var headerHeight = $("#shopify-section-header").height();
      var facetHeight = $(".ais-facets").height();
      if (facetHeight < windowHeight - headerHeight) {
        var top = headerHeight;
        $(".ais-facets").css({ top: top + "px" });
      } else {
        var padding = 80;
        var top = windowHeight - facetHeight - padding;
        $(".ais-facets").css({ top: top + "px" });
      }
    } else {
      $(".ais-facets").css({ top: 0 });
    }
  }
  if ($(".CollectionInner__Sidebar").length > 0) {
    if (window.innerWidth >= 1008) {
      var windowHeight = window.innerHeight;
      var headerHeight = $("#shopify-section-header").height();
      var facetHeight = $(".CollectionInner__Sidebar").height();
      if (facetHeight < windowHeight - headerHeight) {
        var top = headerHeight;
        $(".CollectionInner__Sidebar").css({ top: top + "px" });
      } else {
        var padding = 80;
        var top = windowHeight - facetHeight - padding;
        $(".CollectionInner__Sidebar").css({ top: top + "px" });
      }
    } else {
      $(".CollectionInner__Sidebar").css({ top: 0 });
    }
  }
};

var loadAlternateImages = function () {
  $(".ProductList .ais-hit.ais-product").each(function () {
    var $product = $(this);
    var handle = $(this).data("handle");
    var url =
      window.location.protocol +
      "//" +
      Shopify.shop +
      "/products/" +
      handle +
      ".json";
    var $imageContainer = $(this).find(".ProductItem__ImageWrapper");
    $.ajax({
      type: "GET",
      url: url,
      success: function (data) {
        var images = data.product.images;
        if (images.length > 1) {
          //<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" src="https://cdn.shopify.com/s/files/1/0241/7723/products/EvaDressPinkBack.jpg?v=1595341786">
          var $alternateImage = $("<img>")
            .addClass("ProductItem__Image")
            .addClass("ProductItem__Image--alternate")
            .addClass("Image--lazyLoad")
            .addClass("Image--fadeIn")
            .attr("src", images[1].src)
            .prependTo($imageContainer.find(".AspectRatio"));
          $imageContainer.addClass(
            "ProductItem__ImageWrapper--withAlternateImage"
          );
        }
      },
    });
  });
};

function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function deleteCookie(name) {
  setCookie(name, "", -1);
}

var quickviewSetup = function () {
  if ($(".trigger-quickview").length > 0) {
    $(".trigger-quickview").on("click keydown", function (e) {
      if (e.type == "click" || (e.type === "keydown" && e.key == "Enter")) {
        e.preventDefault();
        var product_url = $(this).closest("a").attr("href");
        $.ajax({
          type: "GET",
          url: product_url + "?view=quickview",
          success: function (response) {
            openModal(response);

            var quickviewJsonData = JSON.parse(
              $(".quickview-modal").find("[data-product-json]").html()
            );
            $(
              ".quickview-modal .SizeSwatchList .HorizontalList__Item .SizeSwatch__Radio",
              document
            ).on("change", quickviewJsonData, quickviewVariantSelect);
            $(
              ".quickview-modal .ProductForm__AddTo .ProductForm__AddToCart"
            ).on("click", onSubmit);
          },
        });
      }
    });
  }
};

function onSubmit(event) {
  event.preventDefault(); // Prevent form to be submitted
  var addToCartButton = event.currentTarget;
  var formHolderElement = addToCartButton.closest("section.Product");

  // First, we switch the status of the button
  addToCartButton.setAttribute("disabled", "disabled");
  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  // Then we add the product in Ajax
  var formElement = formHolderElement.querySelector(
    'form[action*="/cart/add"]'
  );

  fetch(window.theme.localeRootUrl + "/cart/add.js", {
    body: JSON.stringify(getFormData($(formElement))),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    if (response.ok) {
      addToCartButton.removeAttribute("disabled");
      var quickviewOption1 = $('.quickview-modal [name="option-0"]').length
        ? $('.quickview-modal [name="option-0"]:checked').val()
        : null;
      var quickviewOption2 = $('.quickview-modal [name="option-1"]').length
        ? $('.quickview-modal [name="option-1"]:checked').val()
        : null;
      var quickviewOption3 = $('.quickview-modal [name="option-2"]').length
        ? $('.quickview-modal [name="option-2"]:checked').val()
        : null;

      var quickviewJsonData = JSON.parse(
        $(".quickview-modal").find("[data-product-json]").html()
      );
      var quickviewValue = quickviewVariantFromOptions(
        quickviewJsonData["product"],
        quickviewOption1,
        quickviewOption2,
        quickviewOption3
      );
      var currentVariant = null;
      quickviewJsonData["product"]["variants"].forEach(function (variant) {
        if (variant["id"] === quickviewValue) {
          currentVariant = variant;
        }
      });

      closeModal();
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: currentVariant,
            quantity: parseInt(
              formElement.querySelector('[name="quantity"]').value
            ),
          },
        })
      );
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error";
        errorMessageElement.innerHTML = content["description"];
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}

function getFormData($form) {
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function (n, i) {
    indexed_array[n["name"]] = n["value"];
  });

  return indexed_array;
}

function generateModal(content) {
  var modal_html =
    '<div class="quickview-modal-wrapper">' +
    '<button class="trigger-quickview-close"><span>close quickview</span></button>' +
    '<div class="quickview-modal" tabindex="0">' +
    '<div class="quickview-content">' +
    content +
    "</div>" +
    "</div>" +
    "</div>";

  return modal_html;
}

function openModal(content) {
  var modal = generateModal(content);

  //add modal
  $("body").append(modal);

  //add on click events
  $(".trigger-quickview-close").on("click", function () {
    closeModal();
  });

  // gallery.find('.Product__Slideshow')
  //     .flickity(gallery.data('flickity-config'));

  //add body class
  $("body").addClass("quickview-open");
  $(".quickview-modal").focus();
  selectSizeSwatchByKeyboard();

  // This is to build a new Flickity instance on each modal
  const gallery = $(".quickview-modal .Product__Gallery .Product__Slideshow");
  gallery.flickity();
}

function closeModal() {
  //add off click events
  $(
    ".quickview-modal .SizeSwatchList .HorizontalList__Item .SizeSwatch__Radio",
    document
  ).off("change", quickviewVariantSelect);
  $(".trigger-quickview-close").off("click");

  //remove modal and modal content
  $(".quickview-modal-wrapper").remove();

  //remove body class
  $("body").removeClass("quickview-open");
  window.tempHtmlHolder = "";
}

window.onclick = function (event) {
  if (
    $(event.target).closest(".quickview-modal").length == 0 &&
    !$(event.target).hasClass("quickview-modal") &&
    !$(event.target).hasClass("trigger-quickview")
  ) {
    closeModal();
  }
};

function quickviewVariantSelect(evt) {
  var quickviewOption1 = $('.quickview-modal [name="option-0"]').length
    ? $('.quickview-modal [name="option-0"]:checked').val()
    : null;
  var quickviewOption2 = $('.quickview-modal [name="option-1"]').length
    ? $('.quickview-modal [name="option-1"]:checked').val()
    : null;
  var quickviewOption3 = $('.quickview-modal [name="option-2"]').length
    ? $('.quickview-modal [name="option-2"]:checked').val()
    : null;

  var quickviewValue = quickviewVariantFromOptions(
    evt.data.product,
    quickviewOption1,
    quickviewOption2,
    quickviewOption3
  );

  $('select[name="id"] option[value="' + quickviewValue + '"]').prop(
    "selected",
    true
  );
}

function quickviewVariantFromOptions(productData, option1, option2, option3) {
  var found = false;
  productData["variants"].forEach(function (variant) {
    if (
      variant["option1"] === option1 &&
      variant["option2"] === option2 &&
      variant["option3"] === option3
    ) {
      found = variant.id;
    }
  });
  return found || null;
}

jQuery(".Slideshow__Slide").on("click", function () {
  var gogtourl = jQuery(this)
    .find(".Slideshow__Content a.ButtonGroup__Item.Button")
    .attr("href");
  window.location = gogtourl;
});

jQuery(".CollectionItem__Wrapper").on("click", function () {
  var collectionURL = jQuery(this)
    .find("a.CollectionItem__Link.Button")
    .attr("href");
  window.location = collectionURL;
});

jQuery(
  ".FeatureText__ImageWrapper img,.FeatureText__Content .SectionHeader img"
).on("click", function () {
  var imgURL = jQuery(this).attr("data-href");
  window.location = imgURL;
});

function widgetExists() {
  if (window.location.pathname.includes("/products/")) {
    setTimeout(() => {
      if (
        document.querySelector(".ProductMeta quadpay-widget") &&
        document.querySelector(".ProductMeta quadpay-widget").shadowRoot &&
        document
          .querySelector(".ProductMeta quadpay-widget")
          .shadowRoot.querySelector("#qp-container")
      ) {
        document
          .querySelector(".ProductMeta quadpay-widget")
          .shadowRoot.querySelector("#qp-container")
          .classList.remove("qp--align-center");
        document
          .querySelector(".ProductMeta quadpay-widget")
          .shadowRoot.querySelector("#qp-container")
          .classList.add("qp--align-left");
        document
          .querySelector(".ProductMeta quadpay-widget")
          .shadowRoot.querySelector(".qp--wrapped-content")
          .classList.remove("qp--align-center");
        document
          .querySelector(".ProductMeta quadpay-widget")
          .shadowRoot.querySelector(".qp--wrapped-content")
          .classList.add("qp--align-left");
      } else {
        widgetExists();
      }
    }, 200);
  }
}

$(document).ready(function () {
  widgetExists();
  new Swiper(".related_product_carousel .swiper-container", {
    navigation: {
      nextEl: ".related_product_carousel .swiper-button-next",
      prevEl: ".related_product_carousel .swiper-button-prev",
    },
    slidesPerView: 2,
    allowTouchMove: true,
    centeredSlides: false,
    spaceBetween: 20,
    // threshold: 75,
    preventClicks: false,
    paginationClickable: true,
    loop: false,
    breakpoints: {
      1000: {
        slidesPerView: 3,
        loop: false,
      },
      767: {
        slidesPerView: 2,
        loop: false,
        spaceBetween: 15,
      },
      480: {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 15,
      },
      300: {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 15,
      },
    },
  });

  if ($(".related_product_carousel .swiper-slide").length == 2) {
    $(
      ".related_product_carousel .swiper-button-prev,.related_product_carousel .swiper-button-next"
    ).addClass("hidden");
  }
});

$("li.HorizontalList__Item").on("click", function () {
  if ($(this).find(".SizeSwatch__Radio").hasClass("Disabled")) {
    $(".instock_text").hide();
  } else {
    $(".instock_text").show();
  }
});

$(".ProductForm__AddTo").on("click", function () {
  if ($(this).hasClass("disabled")) {
  } else {
    $(".instaock_cart_item").show();
  }
});

$(".ProductForm__AddTo").on("click", function () {
  if ($(this).hasClass("disabled")) {
  } else {
    if ($(".Product__Info .preorder-msg p").length) {
      var preorderText = $(".Product__Info .preorder-msg p").text();
      $(".instaock_cart_item p").text(preorderText);
    }
    $(".instaock_cart_item").show();
  }
});

document.addEventListener("cart:reloaded", function () {
  jQuery.getJSON("/cart.js", function (cart) {
    if (cart.item_count == 0) {
      $(".instaock_cart_item").hide();
    }
  });
});

$(".Pagination__Nav a").each(async function (index) {
  let href = $(this).attr("href");

  const hasProductItem = async function () {
    let response = await fetch(href);
    let HtmlProductPage = await response.text();
    let parser = new DOMParser();
    let htmlDoc = parser.parseFromString(HtmlProductPage, "text/html");
    // Avaliar os scripts antes de inserir o conteúdo no DOM
    const scripts_internal_page = htmlDoc.querySelector(".ProductItem");

    if (scripts_internal_page) {
      return true;
    } else {
      return false;
    }
  };

  let result = await hasProductItem(); // Await the asynchronous function call
  if (!result) {
    $(this).remove();
    if (index < 3) {
      $(".Pagination__NavItem--dots").remove();
    }
  }
});

function selectSizeSwatchByKeyboard() {
  $(".SizeSwatchList .SizeSwatch").on("keydown", function (e) {
    const el = $(this);

    if (e.type === "keydown" && e.key == "Enter") {
      el.trigger("click");
    }
  });
}

selectSizeSwatchByKeyboard();

$(document).ready(function () {
  if ($('#passcode-input').length > 0) {
    const $passwordInput = $('#passcode-input');
    const $togglePasswordBtn = $('[data-eye-icon]');

    $togglePasswordBtn.on('click', function () {
      const type = $passwordInput.attr('type') === 'password' ? 'text' : 'password';
      $passwordInput.attr('type', type);

      if (type === 'password') {
        $('[data-hide-password]').addClass('hidden');
        $('[data-show-password]').removeClass('hidden');
      } else {
        $('[data-hide-password]').removeClass('hidden');
        $('[data-show-password]').addClass('hidden');
      }
    });
  }
});


/* Password Protected Logic */
document.addEventListener('DOMContentLoaded', async function () {
  if (document.querySelector('[data-passcode-page-handle]')) {
    const PASSWORD_SECRET_KEY = document.querySelector('[data-security-key]').dataset.securityKey;
    const PAGE_HANDLE = document.querySelector('[data-passcode-page-handle]').dataset.passcodePageHandle;
    const STORED_HASHED_PASSWORD = document.querySelector('[data-hashed-password]').dataset.hashedPassword;
    const pageContainer = document.querySelector('.PageContainer');
    const passcodePage = document.querySelector('[data-passcode-page]');
    const productCollections = Array.from(
      document.querySelectorAll('[data-product-collection]')
    ).map(el => el.dataset.productCollection);

    const selectors = {
      passwordInput: '[data-passcode-input]',
      form: '[data-passcode-form]',
      passcodePage: '.passcode-page',
      errorMessage: '[data-passcode-error-message]',
    };

    const elements = {
      passwordInput: document.querySelector(selectors.passwordInput),
      form: document.querySelector(selectors.form),
      passcodePage: document.querySelector(selectors.passcodePage),
      errorMessage: document.querySelector(selectors.errorMessage),
    };

    /**
     * @returns {boolean}
     */
    function isPageAccessible() {
      const storedAccess = localStorage.getItem('can_access_pages') || '[]';
      const accessiblePages = JSON.parse(storedAccess);

      if (accessiblePages.includes(PAGE_HANDLE)) {
        return true;
      }

      return productCollections.some(collection => accessiblePages.some(page => page === collection));
    }

    function markPageAsAccessible() {
      const storedAccess = localStorage.getItem('can_access_pages') || '[]';
      const accessiblePages = JSON.parse(storedAccess);

      if (!accessiblePages.includes(PAGE_HANDLE)) {
        accessiblePages.push(PAGE_HANDLE);
        localStorage.setItem('can_access_pages', JSON.stringify(accessiblePages));
      }
    }

    function hidePasscodePage() {
      elements.passcodePage.style.display = 'none';
    }

    function showErrorMessage() {
      elements.errorMessage.classList.remove('hidden');
    }

    function hideErrorMessage() {
      elements.errorMessage.classList.add('hidden');
    }

    /**
     * @param {string} message
     * @param {string} secret
     * @returns {Promise<string>}
     */
    async function hmacSHA1(message, secret) {
      const encoder = new TextEncoder();
      const keyData = encoder.encode(secret);
      const messageData = encoder.encode(message);

      const cryptoKey = await crypto.subtle.importKey(
        'raw',
        keyData,
        { name: 'HMAC', hash: { name: 'SHA-1' } },
        false,
        ['sign']
      );

      const signature = await crypto.subtle.sign('HMAC', cryptoKey, messageData);
      return Array.from(new Uint8Array(signature))
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');
    }

    /**
     * @param {Event} event
     */
    async function handleFormSubmit(event) {
      event.preventDefault();

      const enteredPassword = elements.passwordInput.value;
      const hashedInput = await hmacSHA1(enteredPassword, PASSWORD_SECRET_KEY);

      if (hashedInput === STORED_HASHED_PASSWORD) {
        markPageAsAccessible();
        hidePasscodePage();
        hideErrorMessage();
        location.reload();
      } else {
        showErrorMessage();
      }
    }

    function init() {
      if (isPageAccessible()) {
        hidePasscodePage();
        return;
      } else {
        pageContainer.remove();
        passcodePage.classList.remove('hidden');
      }

      elements.form.addEventListener('submit', handleFormSubmit);
    }

    init();
  }
});


const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

const currentUrl = window.location.href;

function klaviyoButton() {
  setTimeout(() => {
    const iframeElement = document.querySelector("#klaviyo-bis-iframe");
    
    if (iframeElement) {
      const iframeDocument =
        iframeElement.contentDocument || iframeElement.contentWindow.document;
      const klaviyoModalHtml = iframeDocument.querySelector("html");
      const inputEmail = klaviyoModalHtml.querySelector("input#email");
      const button = klaviyoModalHtml.querySelector("button[type='submit']");
      
      const initialErrorContainer = klaviyoModalHtml.querySelector("#error_message");
      if (initialErrorContainer) {
        initialErrorContainer.style.display = "none";
        initialErrorContainer.innerHTML = "";
        initialErrorContainer.removeAttribute("style");
        initialErrorContainer.classList.remove("error_message", "alert", "alert-danger");
      }
      
      if (button) {
        button.addEventListener("click", function () {
          const emailValue = inputEmail.value;
          const errorMessageDiv = klaviyoModalHtml.querySelector("#error_message");
          
          if (errorMessageDiv) {
            errorMessageDiv.style.display = "none";
            errorMessageDiv.innerHTML = "";
            errorMessageDiv.removeAttribute("style");
          }
          
          if (emailValue === "") {
            if (errorMessageDiv) {
              errorMessageDiv.classList.remove("error_message");
              errorMessageDiv.innerHTML = "Please, insert Your Email";
              errorMessageDiv.style.display = "block";
            }
          } else {
            if (errorMessageDiv) {
              errorMessageDiv.style.display = "none";
              errorMessageDiv.innerHTML = "";
              errorMessageDiv.removeAttribute("style");
            }
          }
          
          function handleFirstInput(event) {
            if (errorMessageDiv) {
              errorMessageDiv.classList.add("error_message");
            }
            inputEmail.removeEventListener("input", handleFirstInput);
          }
          inputEmail.addEventListener("input", handleFirstInput);
        });
        
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const successMessage = klaviyoModalHtml.querySelector('[style*="background-color: rgb(211, 239, 205)"]');
              if (successMessage) {
                const errorContainer = klaviyoModalHtml.querySelector("#error_message");
                if (errorContainer) {
                  errorContainer.style.display = "none";
                  errorContainer.innerHTML = "";
                  errorContainer.removeAttribute("style");
                }
              }
            }
          });
        });
        
        observer.observe(klaviyoModalHtml, {
          childList: true,
          subtree: true
        });
        
        const styleCleanupInterval = setInterval(() => {
          const errorContainer = klaviyoModalHtml.querySelector("#error_message");
          if (errorContainer) {
            if (errorContainer.innerHTML.trim() === "" || 
                errorContainer.innerHTML.trim() === "&nbsp;" ||
                errorContainer.textContent.trim() === "") {
              errorContainer.style.display = "none";
              errorContainer.innerHTML = "";
              errorContainer.removeAttribute("style");
              errorContainer.classList.remove("error_message", "alert", "alert-danger");
            }
          }
        }, 50);
        
        setTimeout(() => {
          clearInterval(styleCleanupInterval);
        }, 15000);
      }
    } else {
      if (window.klaviyo) {
        klaviyo.push(['openForm', 'backinstock']);
      }
    }
  }, 1000);
}

const containsProducts = currentUrl.includes("products");
if (containsProducts) {
  function setupKlaviyoButton() {
    const klaviyoModalButton = document.querySelector(".klaviyo-bis-trigger");
    if (klaviyoModalButton) {
      klaviyoModalButton.addEventListener("click", () => {
        klaviyoButton();
        
        setTimeout(() => {
          const iframeElement = document.querySelector("#klaviyo-bis-iframe");
          if (iframeElement) {
            const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;
            const errorContainer = iframeDocument.querySelector("#error_message");
            if (errorContainer) {
              errorContainer.style.display = "none";
              errorContainer.innerHTML = "";
              errorContainer.removeAttribute("style");
              errorContainer.classList.remove("error_message", "alert", "alert-danger");
            }
          }
        }, 1500);
      });
    } else {
      setTimeout(setupKlaviyoButton, 500);
    }
  }
  
  // Only setup Klaviyo button if Back in Stock functionality exists
  if (hasBackInStockFunctionality()) {
    setTimeout(setupKlaviyoButton, 1000);
  }
  
  document.addEventListener("click", function(event) {
    if (event.target.classList.contains("klaviyo-bis-trigger")) {
      klaviyoButton();
      
      setTimeout(() => {
        const iframeElement = document.querySelector("#klaviyo-bis-iframe");
        if (iframeElement) {
          const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;
          const errorContainer = iframeDocument.querySelector("#error_message");
          if (errorContainer) {
            errorContainer.style.display = "none";
            errorContainer.innerHTML = "";
            errorContainer.removeAttribute("style");
            errorContainer.classList.remove("error_message", "alert", "alert-danger");
          }
        }
      }, 1500);
    }
  });
}

// Check if product has any Back in Stock functionality (manual tags or automatic detection)
function hasBackInStockFunctionality() {
  return document.querySelector('.ProductForm__BackInStock') !== null;
}

// Check if product has Coming Soon tag
function hasComingSoonTag() {
  const productTags = window.productTags || [];
  return productTags.some(tag => 
    tag.toLowerCase() === 'coming soon' || tag.toLowerCase() === 'coming-soon'
  );
}

if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.dataset.sectionId}`
        );
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.dataset.sectionId}`
        );
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${this.dataset.sectionId}`
        );
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        );
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        );
        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${this.dataset.sectionId}`
        );
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector(
          ".product-form__recipient-error-message-wrapper"
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector("ul");
        this.errorMessage =
          this.errorMessageWrapper?.querySelector(".error-message");
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener("change", this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm();
            }
          }
        );

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          }
        );

        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors);
            }
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput,
        ];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === "object") {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(", ")}`;
            const errorMessageElement = this.querySelector(
              `#${errorMessageId}`
            );
            const errorTextElement =
              errorMessageElement?.querySelector(".error-message");
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(
                this.createErrorListItem(fieldSelector, message)
              );
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove("hidden");

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute("aria-invalid", true);
            inputElement.setAttribute("aria-describedby", errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.setAttribute("href", target);
        a.innerText = message;
        li.appendChild(a);
        li.className = "error-message";
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = "";

        this.querySelectorAll(".recipient-fields .form__message").forEach(
          (field) => {
            field.classList.add("hidden");
            const textField = field.querySelector(".error-message");
            if (textField) textField.innerText = "";
          }
        );

        [
          this.emailInput,
          this.messageInput,
          this.nameInput,
          this.sendonInput,
        ].forEach((inputElement) => {
          inputElement.setAttribute("aria-invalid", false);
          inputElement.removeAttribute("aria-describedby");
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}

document.addEventListener("cart:reloaded", (e) => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(response => {
      updateFreeShippingBar(response);
    });

});

function updateFreeShippingBar(cart) {
  document.querySelectorAll('.free-shipping-bar').forEach((el) => {
    let threshold = parseInt(el.dataset.freeShippingAmount);
    let difference = 0;

    if(cart.total_price < threshold) {
      difference = ((threshold - cart.total_price) / 100).toFixed(2);
    }

    if(cart.total_price > 0) {
      el.classList.remove('free-shipping-bar--no-cart')
    }
    else {
      el.classList.add('free-shipping-bar--no-cart')
    }

    let progress = Math.min(cart.total_price / threshold, 1);

    el.style.setProperty("--free-shipping-progress", progress);
    el.dataset.freeShippingProgress = progress;
    if(el.querySelector('.amount')) el.querySelector('.amount').innerText = `$${difference}`;
  })
}

function updateTabNavArrows($nav, $arrowLeft, $arrowRight) {
  var scrollLeft = $nav.scrollLeft();
  var maxScroll = $nav[0].scrollWidth - $nav[0].clientWidth;
  if (scrollLeft > 2) {
    $arrowLeft.addClass("ProductTabs__NavArrow--visible");
  } else {
    $arrowLeft.removeClass("ProductTabs__NavArrow--visible");
  }
  if (scrollLeft < maxScroll - 2) {
    $arrowRight.addClass("ProductTabs__NavArrow--visible");
  } else {
    $arrowRight.removeClass("ProductTabs__NavArrow--visible");
  }
}